<template>
    <svg xmlns="http://www.w3.org/2000/svg"
        :fill="svgFill" 
        viewBox="0 0 16 16" 
        class="size-4"
    >
        <path d="M3 4.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM6.25 3a.75.75 0 0 0 0 1.5h7a.75.75 0 0 0 0-1.5h-7ZM6.25 7.25a.75.75 0 0 0 0 1.5h7a.75.75 0 0 0 0-1.5h-7ZM6.25 11.5a.75.75 0 0 0 0 1.5h7a.75.75 0 0 0 0-1.5h-7ZM4 12.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM3 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" />
    </svg>
</template>

<script setup>
import { defineProps, computed } from 'vue';
const props = defineProps(['fill'])

const svgFill = computed(() => {
    return props.fill ? props.fill : 'black'
})
</script>
